import { render } from "./TopicSchema.vue?vue&type=template&id=5b2c32e5&scoped=true"
import script from "./TopicSchema.vue?vue&type=script&lang=js"
export * from "./TopicSchema.vue?vue&type=script&lang=js"

import "./TopicSchema.vue?vue&type=style&index=0&id=5b2c32e5&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2c32e5"]])

export default __exports__